export default "/images/ue-logo.png?3e1167ec15c51cf2e323fb32b0e29773";